import http from '../http'

export function type()
{
  return http.get('api/cex/type')
}

// 下单
export const order = function (data)
{
  return http.post('cex/order', data)
}

// 查询价格
export function query(data)
{
  return order({ ...data, res: 1 })
}

// 地址搜索
export function address(name, type)
{
  return http.post('user/cex_addres', {
    name,
    type
  })
}

// 我的订单
export function user_order(page, where)
{
  return http.get('user/cex_order?page=' + page, {
    params: where
  })
}
